import {
    GET_ASSESSMENTS_REQUEST,
    GET_ASSESSMENTS_SUCCESS,
    GET_ASSESSMENTS_FAILURE
} from '../actions';


const initialState = {};

const AssessmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ASSESSMENTS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_ASSESSMENTS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_ASSESSMENTS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default AssessmentsReducer;